var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.src)?_c('div',{staticClass:"file-list-item__append__item d-flex align-items-center justify-content-center"},[_c('img',{attrs:{"src":_vm.src,"alt":""}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }